import { EntidadFinanciadora } from "../views/Logged/EntidadFinanciadora/EntidadFinanciadora";


export const paths = {
  COMMUNICATIONS: "communications",
  COMMUNICATION_USER: "communications/user",
  ANNOUNCEMENTS: "announcements",
  ANNOUNCEMENTS_USER: "announcements/staff",
  INVESTIGATORS: "staff",
  GROUPS: "investigation-groups",
  AMBITOS: "ambitos",
  investigatorTesis: "staff/tesis",
  LINES: "research-lines",
  TESIS: "tesis",
  INVESTROLE: "investigator-roles",
  USERROLE: "user-roles",
  USERS: "users",
  COMMTYPES: "communication-types",
  PROJECTS: "projects",
  investigatorPROJECT: "staff/project",
  ambitoPROJECT: "project/ambitos",
  entidadFinanciadoraPROJECT: "entidad-financiadora/project",
  entidadParticipantePROJECT: "entidad-participante/project",
  SUBJECTS: "subjects",
  INVESTIGATOR_SUBJECT: "staff/subject",
  SEMINARS: "seminarios",
  PROGRAMS: "programs",
  newUsers: "staff/users",
  TEACHING_RESOURCE: "teaching-resources",
  TEACHING_RESOURCEDOCUMENTS: "teachingResources-documents/teachingResources",
  investigatorGROUP: "staff/investigation-group",
  investigatorAmbito: "staff/ambitos",
  PUBLICATIONS: "publications",
  investigatorPUBLICATION: "staff/publication",
  DEGREES: "degrees",
  DEGREE_TYPES: "degree-types",
  groupPUBLICATION: "investigation-group/publication",
  publicationsByGROUP: "publications/investigation-group",
  publicationsINVESTIGATOR: "publications/staff",
  NEWPASSWORD: "auth/change-password",
  groupSelectPUBLICATION: "investigation-group",
  userSelectPUBLICATION: "staff",
  RESETPASSWORD: "auth/reset-password/user",
  COMMISSIONS: "commissions",
  PATENTS: "patents",
  investigatorPATENT: "staff/patents",
  OFFERS: "offers",
  STAFF_COMMISSION: "staff/commission",
  SLIDERS: "sliders",
  RESOURCES: "resources",
  ENTIDAD_PARTICIPANTE: "entidades-participantes",
  ENTIDAD_FINANCIADORA: "entidades-financiadoras",
  CONVOCATORIAS: "convocatorias",
  PROPUESTAS: "propuestas",
  investigatorPROPUESTA: "staff/propuesta",
  SERIELIBROS: "serie-libros",
  LIBROS: "libros",
  REVISTAS: "revistas",
  EJEMPLARES: "ejemplares",
  RESOURCEFOLDER: "resource-folders",
  INVESTIGADORES_INVITADOS: "investigadores-invitados",
  FINANCIADORAS:"financiadoras"
};
